import { number, object, string } from "yup";
import { stringMax } from "./utils";

export const smtpSchema = object({
  serveur: stringMax(250).required(" "),
  mail: stringMax(250).required(" "),
  port: number().integer().required(" "),
  password: stringMax(250),
});

export const SMTP_INITIAL_VALUES = {
  serveur: "",
  mail: "",
  password: "",
  port: 465,
};

export const signatureMailSchema = object({
  mail_signature: string().required(" "),
});

export const SIGNATURE_MAIL_INITIAL_VALUES = {
  mail_signature: "",
};
